<template>
  <v-row>
    <ProfileInfoDialog ref="profileInfoDialog"></ProfileInfoDialog>
    <v-col xs12 md12 v-if="$vuetify.breakpoint.smAndUp">
      <div class="pb-5 d-flex">
        <span class="display-1 pt-1 font-weight-bold">{{
          $t("profile.general.Profile")
        }}</span>
        <span>
          <v-btn
            :title="$t('profile.general.Click to see more information')"
            icon
            large
            @click.stop="$refs.profileInfoDialog.openDialog()"
          >
            <v-icon color="primary">far fa-question-circle</v-icon>
          </v-btn>
        </span>
      </div>
      <!-- <pre>{{getUser}}</pre> -->
      <v-form @submit.prevent="submitUserChange" v-if="true">
        <v-expansion-panels focusable hover>
          <v-expansion-panel class="grey lighten-1 mt-5 mb-3">
            <v-expansion-panel-header class="title">
              <div style="display:flex;">
                <span
                  >{{ $t("profile.displaySetting.Set display") }} -
                  {{
                    $t(
                      "profile.displaySetting.These are set as disabled by default"
                    )
                  }}</span
                >
                <span class="pl-5">(</span>
                <span
                  v-if="getUser.isName"
                  class="ma-0 pa-0 pl-2 green--text"
                  >{{ $t("profile.displaySetting.Name") }}</span
                >
                <span v-else class="ma-0 pa-0 pl-2 red--text">{{
                  $t("profile.displaySetting.Name")
                }}</span
                >,
                <span
                  v-if="getUser.isCountry"
                  class="ma-0 pa-0 pl-2 green--text"
                >
                  {{ $t("profile.displaySetting.Country") }}</span
                >
                <span v-else class="ma-0 pa-0 pl-2 red--text">
                  {{ $t("profile.displaySetting.Country") }}</span
                >
                ,
                <span
                  v-if="getUser.isGender"
                  class="ma-0 pa-0 pl-2  pr-2 green--text"
                >
                  {{ $t("profile.displaySetting.Gender") }}</span
                >
                <span v-else class="ma-0 pa-0 pl-2 red--text">
                  {{ $t("profile.displaySetting.Gender") }}</span
                >
                <span class="pl-2">)</span>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="grey lighten-2">
              <v-row>
                <v-col md="4" class="mt-0 pt-0 mb-0 pb-0 ml-3">
                  <p v-if="!getUser.isName" class="pb-0 mb-0 pt-5 pb-2">
                    {{ $t("profile.displaySetting.Name are NOT displayed") }}
                  </p>
                  <p v-else class="pb-0 mb-0 pt-5 pb-2 green--text">
                    {{ $t("profile.displaySetting.Name are displayed") }}
                  </p>
                  <span
                    ><v-switch
                      class="ma-0 pa-0"
                      :false-value="0"
                      :true-value="1"
                      v-model="getUser.isName"
                      :label="$t('profile.displaySetting.Display name')"
                    ></v-switch
                  ></span>
                </v-col>
                <v-col md="4" class="mt-0 pt-0 mb-0 pb-0 ml-3">
                  <p v-if="!getUser.isCountry" class="pb-0 mb-0 pt-5 pb-2">
                    {{ $t("profile.displaySetting.Country are NOT displayed") }}
                  </p>
                  <p v-else class="pb-0 mb-0 pt-5 pb-2 green--text">
                    {{ $t("profile.displaySetting.Country are displayed") }}
                  </p>
                  <span
                    ><v-switch
                      class="ma-0 pa-0"
                      :false-value="0"
                      :true-value="1"
                      v-model="getUser.isCountry"
                      :label="$t('profile.displaySetting.Display country')"
                    ></v-switch
                  ></span>
                </v-col>
                <v-col md="auto" class="mt-0 pt-0 mb-0 pb-0 ml-3">
                  <p v-if="!getUser.isGender" class="pb-0 mb-0 pt-5 pb-2">
                    {{ $t("profile.displaySetting.Gender are NOT displayed") }}
                  </p>
                  <p v-else class="pb-0 mb-0 pt-5 pb-2 green--text">
                    {{ $t("profile.displaySetting.Gender are displayed") }}
                  </p>
                  <span
                    ><v-switch
                      class="ma-0 pa-0"
                      :false-value="0"
                      :true-value="1"
                      v-model="getUser.isGender"
                      :label="$t('profile.displaySetting.Display Gender')"
                    ></v-switch
                  ></span>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <v-container grid-list-xl>
          <v-row>
            <v-col md="4">
              <v-select
                filled
                :items="choices.sex"
                :label="$t('profile.form.Sex')"
                v-model="getUser.Sex"
              ></v-select>
            </v-col>
            <v-col md="4">
              <v-text-field
                filled
                :label="$t('profile.form.Last Name')"
                v-model="getUser.LastName"
              ></v-text-field>
            </v-col>
            <v-col md="4">
              <v-text-field
                filled
                :label="$t('profile.form.First Name')"
                v-model="getUser.FirstName"
              ></v-text-field>
            </v-col>

            <v-col md="6">
              <v-text-field
                filled
                :label="$t('profile.form.Phone')"
                v-model="getUser.Phone"
              ></v-text-field>
              <v-text-field
                filled
                :label="$t('profile.form.Address')"
                v-model="getUser.Address"
              ></v-text-field>
              <v-layout>
                <v-flex sm4>
                  <v-text-field
                    filled
                    :label="$t('profile.form.Postal Code')"
                    type="number"
                    v-model="getUser.PostalCode"
                  ></v-text-field>
                </v-flex>
                <v-flex sm8>
                  <v-text-field
                    filled
                    :label="$t('profile.form.City')"
                    v-model="getUser.City"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-text-field
                filled
                :label="$t('profile.form.Country')"
                v-model="getUser.Country"
              ></v-text-field>
              <v-flex xs12 text-xs-left>
                <v-btn class color="success" type="submit">{{
                  $t("profile.general.Update Profile")
                }}</v-btn>
              </v-flex>
            </v-col>
            <v-col md="6">
              <v-text-field
                filled
                :label="$t('profile.form.Email')"
                v-model="getUser.Email"
              ></v-text-field>
              <v-select
                filled
                :items="getLanguages"
                item-text="name"
                item-value="code"
                :label="$t('profile.form.Language')"
                v-model="getUser.Lang"
              ></v-select>
              <v-textarea
                auto-grow
                filled
                :label="$t('profile.form.About Me')"
                v-model="getUser.About"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-col>
    <!--Phone-->
    <v-col v-else>
      <v-form @submit.prevent="submitUserChange" v-if="true">
        <v-row class="ma-0 pa-0">
          <!--Headliner + Helper dialog-->
          <v-col class="py-0" cols="12">
            <div class="pb-5 d-flex">
              <span class="display-1 pt-1 font-weight-bold">{{
                $t("profile.general.Close Window")
              }}</span>
              <span>
                <v-btn
                  :title="$t('profile.general.Click to see more information')"
                  icon
                  large
                  @click.stop="$refs.profileInfoDialog.openDialog()"
                >
                  <v-icon color="primary">far fa-question-circle</v-icon>
                </v-btn>
              </span>
            </div>
          </v-col>
          <!--Display Settings-->
          <v-col class="py-0" cols="12">
            <v-expansion-panels focusable hover>
              <v-expansion-panel class="grey lighten-1 mt-5 mb-3">
                <v-expansion-panel-header class="title">
                  <v-row class="ma-0 pa-0">
                    <v-col cols="12" class="py-0">
                      <span>{{
                        $t("profile.displaySetting.Set display")
                      }}</span>
                    </v-col>
                    <v-col cols="12" class="py-0">
                      <span>(</span>
                      <span
                        v-if="getUser.isName == 0"
                        class="ma-0 pa-0 pl-1 red--text"
                        >{{ $t("profile.displaySetting.Name") }}</span
                      >
                      <span
                        v-if="getUser.isName == 1"
                        class="ma-0 pa-0 pl-1 green--text"
                        >{{ $t("profile.displaySetting.Name") }}</span
                      >,
                      <span
                        v-if="getUser.isCountry == 0"
                        class="ma-0 pa-0 pl-1 red--text"
                      >
                        {{ $t("profile.displaySetting.Country") }}</span
                      >
                      <span
                        v-if="getUser.isCountry == 1"
                        class="ma-0 pa-0 pl-1 green--text"
                      >
                        {{ $t("profile.displaySetting.Country") }}</span
                      >,
                      <span
                        v-if="getUser.isGender == 0"
                        class="ma-0 pa-0 pl-1 red--text"
                      >
                        {{ $t("profile.displaySetting.Gender") }}</span
                      >
                      <span
                        v-if="getUser.isGender == 1"
                        class="ma-0 pa-0 pl-1  pr-1 green--text"
                      >
                        {{ $t("profile.displaySetting.Gender") }}</span
                      >
                      <span class="pl-2">)</span>
                    </v-col>
                  </v-row>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="grey lighten-2">
                  <v-row class="ma-0 pa-0">
                    <v-col cols="12" class="mt-0 pt-0 mb-0 pb-0 ml-3">
                      <p v-if="getUser.isName == 0" class="pb-0 mb-0 pt-5">
                        {{
                          $t("profile.displaySetting.Name are NOT displayed")
                        }}
                      </p>
                      <p
                        v-if="getUser.isName == 1"
                        class="pb-0 mb-0 pt-5 green--text"
                      >
                        {{ $t("profile.displaySetting.Name are displayed") }}
                      </p>
                      <span
                        ><v-switch
                          class="ma-0 pa-0"
                          :false-value="0"
                          :true-value="1"
                          v-model="getUser.isName"
                          :label="$t('profile.displaySetting.Display name')"
                        ></v-switch
                      ></span>
                    </v-col>
                    <v-col cols="12" class="mt-0 pt-0 mb-0 pb-0 ml-3">
                      <p v-if="getUser.isCountry == 0" class="pb-0 mb-0">
                        {{
                          $t("profile.displaySetting.Country are NOT displayed")
                        }}
                      </p>
                      <p
                        v-if="getUser.isCountry == 1"
                        class="pb-0 mb-0 green--text"
                      >
                        {{ $t("profile.displaySetting.Country are displayed") }}
                      </p>
                      <span
                        ><v-switch
                          class="ma-0 pa-0"
                          :false-value="0"
                          :true-value="1"
                          v-model="getUser.isCountry"
                          :label="$t('profile.displaySetting.Display country')"
                        ></v-switch
                      ></span>
                    </v-col>
                    <v-col cols="12" class="mt-0 pt-0 mb-0 pb-0 ml-3">
                      <p v-if="getUser.isGender == 0" class="pb-0 mb-0 pb-2">
                        {{
                          $t("profile.displaySetting.Gender are NOT displayed")
                        }}
                      </p>
                      <p
                        v-if="getUser.isGender == 1"
                        class="pb-0 mb-0 pb-2 green--text"
                      >
                        {{ $t("profile.displaySetting.Gender are displayed") }}
                      </p>
                      <span
                        ><v-switch
                          class="ma-0 pa-0"
                          :false-value="0"
                          :true-value="1"
                          v-model="getUser.isGender"
                          :label="$t('profile.displaySetting.Display Gender')"
                        ></v-switch
                      ></span>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
          <!--Gender-->
          <v-col class="py-0" cols="12">
            <v-select
              filled
              :items="choices.sex"
              :label="$t('profile.form.Sex')"
              v-model="getUser.Sex"
            ></v-select>
          </v-col>
          <!--Last Name-->
          <v-col class="py-0" cols="12">
            <v-text-field
              filled
              :label="$t('profile.form.Last Name')"
              v-model="getUser.LastName"
            ></v-text-field>
          </v-col>
          <!--First Name-->
          <v-col class="py-0" cols="12">
            <v-text-field
              filled
              :label="$t('profile.form.First Name')"
              v-model="getUser.FirstName"
            ></v-text-field>
          </v-col>
          <!--Phone-->
          <v-col class="py-0" cols="12">
            <v-text-field
              filled
              :label="$t('profile.form.Phone')"
              v-model="getUser.Phone"
            ></v-text-field>
          </v-col>
          <!--Adress-->
          <v-col class="py-0" cols="12">
            <v-text-field
              filled
              :label="$t('profile.form.Address')"
              v-model="getUser.Address"
            ></v-text-field>
          </v-col>
          <!--Post nr-->
          <v-col class="py-0" cols="12">
            <v-text-field
              filled
              :label="$t('profile.form.Postal Code')"
              type="number"
              v-model="getUser.PostalCode"
            ></v-text-field>
          </v-col>
          <!--City-->
          <v-col class="py-0" cols="12">
            <v-text-field
              filled
              :label="$t('profile.form.City')"
              v-model="getUser.City"
            ></v-text-field>
          </v-col>
          <!--Country-->
          <v-col class="py-0" cols="12">
            <v-text-field
              filled
              :label="$t('profile.form.Country')"
              v-model="getUser.Country"
            ></v-text-field>
          </v-col>
          <!--Language-->
          <v-col class="py-0" cols="12">
            <v-select
              filled
              :items="getLanguages"
              item-text="name"
              item-value="code"
              :label="$t('profile.form.Language')"
              v-model="getUser.Lang"
            ></v-select>
          </v-col>
          <!--About me-->
          <v-col class="py-0" cols="12">
            <v-textarea
              auto-grow
              filled
              :label="$t('profile.form.About Me')"
              v-model="getUser.About"
            ></v-textarea>
          </v-col>
          <!--Update Button-->
          <v-col class="py-0" cols="12">
            <v-btn block class color="success" type="submit">{{
              $t("profile.general.Update Profile")
            }}</v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-col>
  </v-row>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import messages from "./modules/lang/main/export";
import ProfileInfoDialog from "@/components/informational_dialogs/private/profile_info_dialog.vue";
export default {
  i18n: { messages },
  components: {
    ProfileInfoDialog
  },
  data() {
    return {
      // Privacy setting, to display through the app.
      privacySetting: {
        DisplayName: false,
        DisplayCountry: false,
        DisplayGender: false
      },
      DialogEditTagProfile: false,
      EditTagProfile: {
        name: "",
        id: null,
        geotags: [],
        maintags: []
      },
      UserArticleHeaders: [
        { text: "Id", value: "id" },
        { text: "Title", value: "Title" },
        { text: "Created", value: "Created" },
        { text: "Updated", value: "Updated" },
        { text: "Published", value: "Published" },
        { text: "MediaId", value: "MediaId" }
      ],
      choices: {
        sex: [
          { text: "Male", value: "M" },
          { text: "Female", value: "F" }
        ],
        language: [
          { text: "Norwegian", value: "nb" },
          { text: "English", value: "en" },
          { text: "Spanish", value: "es" }
        ]
      }
    };
  },
  computed: {
    ...mapGetters([
      "isLoggedIn",
      "authStatus",
      "getUser",
      "updateStatus",
      "getLanguages"
    ])
    //     ...mapGetters(["getUser", "GeoTags", "MainTags", "UserArticles"])
  },
  watch: {
    updateStatus() {
      switch (this.updateStatus) {
        case "loading":
          this.$emit("snackbarevent", "Please wait while we save the data.");
          break;
        case "error":
          this.$emit(
            "snackbarevent",
            "An error occurred while saving the data."
          );
          break;
        case "success":
          this.$emit("snackbarevent", "Saved successfully");
          break;
        default:
          this.$emit("snackbarevent", "Saved successfully");
      }
    }
  },
  methods: {
    ...mapActions(["updateUser"]),
    submitUserChange() {
      this.getUser.FullName =
        this.getUser.FirstName != "" && this.getUser != ""
          ? [this.getUser.FirstName, this.getUser.LastName].join(" ")
          : this.getUser.Email;
      this.updateUser({ ...this.getUser });
      // this.$root.changeLocale(this.getUser.Lang);

      // this.$moment.locale(this.getUser.Lang);
    },
    saveDialogEditProfile() {
      //  let _output = {
      //    id: this.EditTagProfile.id,
      //    name: this.EditTagProfile.name,
      //    userid: this.userData.id,
      //    Tags: this.EditTagProfile.geotags.concat(this.EditTagProfile.maintags)
      //  };
      //  instance.post("/user/tagprofile", _output).then(res => {
      //    this.fetchUser().then(res => {
      //      this.closeDialogEditProfile();
      //    });
      //  });
    },
    DeleteUserTagProfile() {
      //  let _answer = confirm("Are you sure you want to delete this profile?");
      //  if (_answer) {
      //    let _output = {
      //      params: {
      //        id: this.EditTagProfile.id,
      //        delete: true
      //      }
      //    };
      //    instance.delete("/user/tagprofile", _output).then(res => {
      //      this.fetchUser().then(res => {
      //        this.closeDialogEditProfile();
      //      });
      //    }).catch(res => {
      //      alert("This profile is in use, and cant be deleted")
      //    });
      //  }
    },
    closeDialogEditProfile() {
      //  this.EditTagProfile.geotags = [];
      //  this.EditTagProfile.maintags = [];
      //  this.EditTagProfile.name = "";
      //  this.EditTagProfile.id = null;
      //  this.DialogEditTagProfile = false;
    },
    editTagProfile(id) {
      //  if (!isNaN(id)) {
      //    let _EditTagProfile = this.userData.TagProfiles.find(
      //      res => res.id == id
      //    );
      //    this.EditTagProfile.geotags = _EditTagProfile.tags
      //      .filter(res => res.TypeId == 1)
      //      .map(res => res.id);
      //    this.EditTagProfile.maintags = _EditTagProfile.tags
      //      .filter(res => res.TypeId == 2)
      //      .map(res => res.id);
      //    this.EditTagProfile.name = _EditTagProfile.name;
      //    this.EditTagProfile.id = _EditTagProfile.id;
      //  }
      //  this.DialogEditTagProfile = true;
    },
    GoToArticle(id) {
      //  this.$router.push({ path: "/article/" + id });
    },
    //     ...mapActions(["fetchUser", "UserChange", "fetchUserArticles"]),
    updateProfile() {
      //  this.snackbartext = "Saving profile...";
      //  this.snackbar = true;
      //  instance.post("/users", this.userData).then(res => {
      //    instance
      //      .post("/user/get", {
      //        auth: this.userData.AuthId
      //      })
      //      .then(res => {
      //        this.$store.commit("setUser", {
      //          user: res.data
      //        });
      //        this.snackbartext = "Profile saved";
      //        this.snackbar = true;
      //      });
      //  });
    },
    removeGeoTag(item) {
      //  let index = this.EditTagProfile.geotags.indexOf(item.id);
      //  if (index >= 0) this.EditTagProfile.geotags.splice(index, 1);
    },
    removeMainTag(item) {
      //  let index = this.EditTagProfile.maintags.indexOf(item.id);
      //  if (index >= 0) this.EditTagProfile.maintags.splice(index, 1);
    }
  },
  mounted() {}
};
</script>
